export default "__VITE_ASSET__CjQh$FNC__"